export const VERSION = '4.2.12-gogreen';
export const GIT_HASH = '97c9dd3dd4ed624927310ab7b7afb5f5d8fd9259';
export const BUILD_DATE = '';
export const CLIENT_BRAND = 'gg';
